import { useLanguage } from "@/LanguageContext";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export default function LegalPage({ onBack }) {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-[#F0EBE3] pt-28 pb-20" data-testid="legal-page">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <button
          onClick={onBack}
          className="flex items-center gap-2 font-body text-sm text-[#6FA8B6] hover:text-[#5B8D9A] transition-colors mb-10"
          data-testid="legal-back-button"
        >
          <ArrowLeft size={16} strokeWidth={1.5} />
          {language === "de" ? "Zurück" : language === "en" ? "Back" : "Retour"}
        </button>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-heading text-3xl sm:text-4xl tracking-tight text-[#2C3E50] mb-12">
            {language === "de" ? "Impressum" : language === "en" ? "Legal Notice" : "Mentions légales"}
          </h1>

          <div className="space-y-10 font-body text-[#2C3E50]/80 leading-relaxed">
            <div>
              <h2 className="font-heading text-xl text-[#2C3E50] mb-3">
                {language === "de" ? "Herausgeber der Website" : language === "en" ? "Site Publisher" : "Éditeur du site"}
              </h2>
              <p>Présence & Sourire</p>
              <p>Giada Vento</p>
              <p>{language === "de" ? "Wallis, Schweiz" : language === "en" ? "Valais, Switzerland" : "Valais, Suisse"}</p>
              <p className="mt-3">
                {language === "de" ? "Telefon" : language === "en" ? "Phone" : "Téléphone"} : 078 329 33 18
              </p>
              <p>Email : info_presenceetsourire@etik.com</p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-[#2C3E50] mb-3">
                {language === "de" ? "Verantwortlich für den Inhalt" : language === "en" ? "Content Manager" : "Responsable du contenu"}
              </h2>
              <p>Giada Vento</p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-[#2C3E50] mb-3">
                {language === "de" ? "Hosting" : language === "en" ? "Hosting" : "Hébergement"}
              </h2>
              <p>[{language === "de" ? "Name des Hosters" : language === "en" ? "Hosting provider name" : "Nom de l'hébergeur"} – ex : Hostinger, Infomaniak, etc.]</p>
              <p>[{language === "de" ? "Adresse des Hosters" : language === "en" ? "Hosting provider address" : "Adresse de l'hébergeur"}]</p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-[#2C3E50] mb-3">
                {language === "de" ? "Geistiges Eigentum" : language === "en" ? "Intellectual Property" : "Propriété intellectuelle"}
              </h2>
              <p>
                {language === "de"
                  ? "Der gesamte Inhalt dieser Website (Texte, Bilder, Logo, Design) ist ausschliessliches Eigentum von Présence & Sourire, sofern nicht anders angegeben. Jede Vervielfältigung, Verbreitung oder Nutzung ohne Genehmigung ist untersagt."
                  : language === "en"
                  ? "All content on this site (texts, images, logo, design) is the exclusive property of Présence & Sourire, unless otherwise stated. Any reproduction, distribution or use without authorization is prohibited."
                  : "L'ensemble du contenu présent sur ce site (textes, images, logo, design) est la propriété exclusive de Présence & Sourire, sauf mention contraire. Toute reproduction, distribution ou utilisation sans autorisation est interdite."}
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-[#2C3E50] mb-3">
                {language === "de" ? "Haftung" : language === "en" ? "Liability" : "Responsabilité"}
              </h2>
              <p>
                {language === "de"
                  ? "Die auf dieser Website enthaltenen Informationen dienen nur zu Informationszwecken. Présence & Sourire kann nicht für etwaige Fehler oder Auslassungen haftbar gemacht werden."
                  : language === "en"
                  ? "The information on this site is provided for informational purposes only. Présence & Sourire cannot be held responsible for any errors or omissions."
                  : "Les informations présentes sur ce site sont fournies à titre informatif. Présence & Sourire ne saurait être tenue responsable d'éventuelles erreurs ou omissions."}
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-[#2C3E50] mb-3">
                {language === "de" ? "Anwendbares Recht" : language === "en" ? "Applicable Law" : "Droit applicable"}
              </h2>
              <p>
                {language === "de"
                  ? "Diese Website unterliegt dem Schweizer Recht."
                  : language === "en"
                  ? "This site is subject to Swiss law."
                  : "Le présent site est soumis au droit suisse."}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
